import $ from "jquery"

window.onPageLoad = (f) -> $(f)
#window.onPageLoad = (f) -> $(document).on('turbolinks:load', f)
